<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData" @uploadSuc="uploadSuc"></UPDATE>
    <UPDATE  ref="phoneChildUpdate"  @submit="phoneSubmit" :updateData="phoneUpdateData" @uploadSuc="phoneUploadSuc"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import Url from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let status = {0:"未发送",1:"已发送"}
  let channel = {"xk":"先客国际","mxt":"麦讯通"}
  let pushType = {}
  let pushObj = {}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created(){
      this.$axios.post(Url.smsTemplate.list).then(res=> {
        console.log(res);
        if (res.code == 0){
          for (let i in res.result) {
            if (res.result[i].sendType == 1){
              pushType[res.result[i].pushType] = res.result[i].pushType;
              pushObj[res.result[i].pushType] = res.result[i];
            }
          }
          console.log(pushType);
          console.log(pushObj);
        }
      })
    },
    methods: {
      uploadSuc(col,result,cols){
        col.data = (result || []).join(",");
        let userCol = {};
        for (let i in cols){
          if (cols[i].field == "customers") userCol = cols[i];
        }
        let data =(result || []).join(",");
        this.$set(userCol,"data",data);
      },
      phoneUploadSuc(col,result,cols){
        col.data = (result || []).join(",");
        let userCol = {};
        for (let i in cols){
          if (cols[i].field == "phones") userCol = cols[i];
        }
        let data =(result || []).join(",");
        this.$set(userCol,"data",data);
      },
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete"){
          this.dataChanage(Url.smsTask.delete,{id:row.id},res =>{
            this.$refs.childTable.defaultQueryData(this.queryData);
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          });
        }else if (clickName == "send"){
          this.dataChanage(Url.smsTask.send,{id:row.id},res =>{
            this.$refs.childTable.defaultQueryData(this.queryData);
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增客户账号" == clickName){
          this.$refs.childUpdate.open();
        } else if("新增客户手机号" == clickName){
          this.$refs.phoneChildUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.smsTask.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error("suc");
          }
        })
      },
      phoneSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.smsTask.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.phoneChildUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error("suc");
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id',hidden: true},
            { title: '上传名单', field: 'uploadList',type:11,action:Url.smsTask.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
            { title: '发送名单', field: 'customers',placeholder:'多个使用逗号隔开',textType:"textarea",required:true},
            { title: '短信通道', field: 'channel',type: 2,optionList: channel,required:true},
            { title: '发送时间', field: 'pushTime',type: 5,format: 'yyyy-MM-dd HH',required:true},
            { title: '推送类别', field: 'pushType',type: 2,optionList: pushType ,change:(updateModel,cols,col)=>{
                let targetCol = {};
                for (let i in cols){
                  if (cols[i].field == "content") targetCol = cols[i];
                }
                this.$set(targetCol,"data",pushObj[col.data].content);
              },required:true},
            { title: '短信内容', field: 'content',readonly:true,required:true},
            { title: '状态', field: 'status',data: 0,hidden: true},
          ]
        },
        phoneUpdateData:{
          cols:[
            { title: 'id', field: 'id',hidden: true},
            { title: '上传手机号', field: 'uploadList',type:11,action:Url.smsTask.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
            { title: '发送手机号', field: 'phones',placeholder:'多个使用逗号隔开',textType:"textarea",required:true},
            { title: '短信通道', field: 'channel',type: 2,optionList: channel,required:true},
            { title: '发送时间', field: 'pushTime',type: 5,format: 'yyyy-MM-dd HH',required:true},
            { title: '推送类别', field: 'pushType',type: 2,optionList: pushType ,change:(updateModel,cols,col)=>{
                let targetCol = {};
                for (let i in cols){
                  if (cols[i].field == "content") targetCol = cols[i];
                }
                this.$set(targetCol,"data",pushObj[col.data].content);
              },required:true},
            { title: '短信内容', field: 'content',readonly:true,required:true},
            { title: '状态', field: 'status',data: 0,hidden: true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols: [
            { title: '发送开始时间', field: 'startTime',type: 5,format: 'yyyy-MM-dd HH'},
            { title: '发送结束时间', field: 'endTime',type: 5,format: 'yyyy-MM-dd HH'},
            { title: '推送类别', field: 'pushType'},
            { title: '短信内容', field: 'content'},
            { title: '状态', field: 'status',type: 2, optionList: status,isNumber: true},
            {click:"查询",auth:"cfint:smstask:query"},
            {click:"新增客户账号",auth:"cfint:smstask:add"},
            {click:"新增客户手机号",auth:"cfint:smstask:addPhone"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.smsTask.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
            { title: '账号', field: 'customers'},
            { title: '手机号', field: 'phones'},
            { title: '发送时间', field: 'pushTime'},
            { title: '推送类别', field: 'pushType'},
            { title: '短信内容', field: 'content'},
            { title: '状态', field: 'status',render: (data, full) => {
                return status[data];
              }},
            { title: '短信通道', field: 'channel',render: (data, full) => {
                return channel[data];
              }},
            { title: '更新人', field: 'updater'},
            { title: '更新时间', field: 'updateTime',render: (data, full) => {
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            {title:"操作", btnClick: [
                { name: "修改", size: 'mini', click: 'update', type: 'primary' ,icon:"el-icon-update",hidden:(data,full)=>{
                    return full.status == 1;
                  },auth:"cfint:smstask:update"},
                { name: "删除", size: 'mini', click: 'delete', type: 'primary' ,icon:"el-icon-delete",hidden:(data,full)=>{
                    return full.status == 1;
                  },auth:"cfint:smstask:delete"},
                { name: "发送", size: 'mini', click: 'send', type: 'primary' ,icon:"el-icon-update",hidden:(data,full)=>{
                    return full.status == 1;
                  },auth:"cfint:smstask:send"},
              ]
            }
          ]
        }
      }
    }
  }
</script>
